import { render } from "./vAccordion.vue?vue&type=template&id=6f9c2cbd&scoped=true&ts=true"
import script from "./vAccordion.vue?vue&type=script&lang=ts"
export * from "./vAccordion.vue?vue&type=script&lang=ts"

import "./vAccordion.vue?vue&type=style&index=0&id=6f9c2cbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9c2cbd"]])

export default __exports__